const Labels : {[key: string]: string} = {
    benef: "bénéficiaire",
    benefs: "bénéficiaires",
    echeancier: "échéancier",
    evenements: "évènements",
    refExterne: "référent externe",
    seances: "séances",
    signatureBenef: "signature bénéficiaire",
    signatureAnim: "signature animateur",
    societe: "société",
    tel: "téléphone",
    seance: "séance",
    donneurOrdre: "donneur d'ordre",
};

export default Labels;